import React from 'react';
import { CircularProgress, Box, Typography } from '@mui/material';

const Loading = ({ message = '로딩 중...', size = 'medium', fullScreen = false }) => {
  const sizes = {
    small: 24,
    medium: 40,
    large: 56
  };

  const containerStyles = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    padding: '24px',
    borderRadius: '12px',
    ...(fullScreen && {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(4px)',
      zIndex: 9999,
    })
  };

  return (
    <Box sx={containerStyles}>
      <CircularProgress 
        size={sizes[size]} 
        sx={{
          color: '#2563eb',
          '& .MuiCircularProgress-circle': {
            strokeLinecap: 'round',
          }
        }}
      />
      {message && (
        <Typography 
          variant="body1" 
          sx={{
            color: '#4b5563',
            fontSize: '0.95rem',
            fontWeight: 500,
            textAlign: 'center',
            maxWidth: '80%',
            margin: '0 auto'
          }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default Loading;
